function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 6.87504C22 9.88561 19.25 12.1822 16.3157 11.5648C15.6842 12.6992 13.8844 13.9969 11.7713 12.9959C10.3564 16.2976 5.65632 16.1646 4.42156 12.8182C0.306168 13.6394 -1.72541 8.06167 1.83414 5.96788C0.639607 3.23745 2.6124 0 5.76357 0C6.41888 0.000406994 7.06531 0.151611 7.65282 0.441906C8.24032 0.732202 8.75315 1.1538 9.15159 1.67407C9.86316 0.938442 10.8497 0.477471 11.9411 0.477471C13.3966 0.477471 14.6568 1.28598 15.3374 2.49083C18.5281 1.09244 22 3.46124 22 6.87504Z",
  fill: "white"
});

const SvgSalesforce = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSalesforce, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/salesforce.04386681.svg";
export { ForwardRef as ReactComponent };